import { isAuthenticated } from '../utils/authHelper';
import React from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import RaisedButton from 'material-ui/RaisedButton';
import {
  Grid,
  Select,
  TextField,
  MenuItem,
  ListItemText,
  FormControl,
  InputLabel,
  FormHelperText,
  Paper,
  Button,
  IconButton,
  Snackbar,
  Tooltip,
  Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText,
   FormControlLabel, FormLabel
} from '@material-ui/core';
import Info from '@material-ui/icons/Info'
import Table from './Table'
import Header from './Header'
import { browserHistory } from 'react-router'
import token from '../config/jwt_token'
import DialogBox from './Dialogbox'
import { getStatesAndCities } from '../utils/VendorApiUtils'
import moment from 'moment'
import { validateCenterName, addCostCenter } from '../utils/costCenterUtils'

const errorText = 'This field is required';
const existsErrorText = 'Cost Centre with this name already exists';

const styles = {
  formControl: {
    margin: 0,
    fullWidth: true,
    backgroundColor: '#9ee',
    display: 'flex',
    wrap: 'nowrap'
  },
 }

class AddCostCenter extends React.Component {
  constructor(props) {
    super(props)
    if (!isAuthenticated()) {
      browserHistory.push('/')
    }
    this.state = {
      cities: [], //[ {id: 1, name:'Bangalore'}, {id: 2, name:'Chennai'}, {id: 3, name:'Pune'}, {id: 4, name:'Kota'}, {id: 5, name:'Hyderabad'}, {id: 6, name:'Noida'} ,{id: 7, name:'Mumbai'}, {id: 8, name:'Coimbatore'}, {id: 9, name:'Gurugram'}],
      data: {
        centerId:'',
        zoloCode:'',
        name:'',
        citySelected: '',
        genderSelected: '',
        ccTypeSelected: '',
        staffSelected: ''
      },
      gender: [ {id: 1, name:'Men'}, {id: 2, name:'Women'}, {id: 3, name:'Unisex'}, {id: 4, name:'Not Applicable'}],
      ccType: [ {id: 1, name:'Property'}, {id: 2, name:'Kitchen'}, {id: 3, name:'Office'}, {id: 4, name:'Temporary'}],
      staff: [ {id: 1, name:'BCS'}, {id: 2, name:'OSS'}],
      columns: [],
      fromDate: '',
      toDate: '',
      fromDateErr: false,
      fromDateErrText: '',
      toDateErr: false,
      toDateErrText: '',
      showDialogBox: false,
      snackOpen: false,
      open: false,
      snackText: '',
      nameDuplicate: false,
      selectGenderErrText: null,
      selectStaffErrText: null,
      selectccTypeErrText: null,
      selectCityErrText: null,
      selectNameErrText: null,
      nameValidText: null,
      nameInvalidText: null,
      submitDisable: false,
    }
    this.handleNameValidation = this.handleNameValidation.bind(this);
  }
  async componentDidMount() {
    if (!token || (token.role !== 'root' && token.role !== 'Central Finance' && token.role !== 'Super Central Finance')) {
      browserHistory.push('/')
      return
    }
    getStatesAndCities().then((response) => {
      if (response && response.status === 'success') {
        this.setState({ cities: response.data })
      }
    })
  }
  handleChange = (props) => async(event, index, value)=>{
    switch(props){
      case 'name':
      if(this.state.selectNameErrText){this.setState({selectNameErrText: null})}
      this.setState({ data: {...this.state.data, name: event.target.value}, nameErrorText: '' })
        break;
      case 'city':
        this.setState({ data: {...this.state.data, citySelected: event.target.value}, cityErrorText: '' })
        break;
      case 'gender':

        this.setState({ data: {...this.state.data, genderSelected: event.target.value}, genderErrorText: '' })
        break;
      case 'ccType':

        this.setState({ data: {...this.state.data, ccTypeSelected: event.target.value}, ccTypeErrorText: '' })
        break;
      case 'staff':

        this.setState({ data: {...this.state.data, staffSelected: event.target.value}, staffErrorText: '' })
        break;
    }
    return;
  }

  generateZoloCode= () => {
    var type;
    var data = this.state.data;
    switch(data.ccTypeSelected){
      case 'Property': type = 'PRP_'
        break;
      case 'Kitchen': type = 'KT_'
        break;
      case 'Office': type = 'OFF_'
        break;
      case 'Temporary': type = 'TEMP_'
        break;
    }
    return type + data.name.substr(0, 5) + '_' + moment().unix();
  }

  handleSubmit = () => {
    this.setState({submitDisable: true});
    this.validateEmpty();
    if (this.state.data.name !== '' && this.state.data.genderSelected !== ''
      && this.state.data.citySelected !== null && this.state.data.ccTypeSelected !== 0
      && this.state.data.staffSelected !== '' && !this.state.nameDuplicate) {
        //Generate the two ids
        let zoloCode = this.generateZoloCode();
        let centerId = 'ID_' + zoloCode;
        let costCenterData = {...this.state.data};
        costCenterData.name = 'Zolo ' + costCenterData.name;
        let data = {...(costCenterData), zoloCode: zoloCode, centerId: centerId}
        addCostCenter(data).then((response) => {
          if (response && response.status === 'success') {
            this.setState({snackOpen: true, snackText: 'Submitted!'});
            this.handleClear();
          }
          else
          this.setState({snackOpen: true, snackText: 'Error in Submitting form!'});
          this.setState({submitDisable: false});
        })
        .catch((err)=>{
          this.setState({snackOpen: true, snackText: err});
          this.setState({submitDisable: false});
        });
      }
    else {
      this.setState({snackOpen: true, snackText: 'Invalid Entry(s)!'});
      this.setState({submitDisable: false});
    }
    return;
  }

  handleClear = () => {
    this.setState({
      data: {
        name:'',
        citySelected: '',
        genderSelected: '',
        ccTypeSelected: '',
        staffSelected: ''
      },
      nameDuplicate: false,
      selectGenderErrText: null,
      selectStaffErrText: null,
      selectccTypeErrText: null,
      selectCityErrText: null,
      selectNameErrText: null,
      nameValidText: null,
      nameInvalidText: null,
    });
    return;
  }

  validateEmpty = () => {
    if (this.state.data.citySelected === '') {
      this.setState({ selectCityErrText: errorText});
    }
    else 
      this.setState({ selectCityErrText: null});

    if (this.state.data.genderSelected === '') {
      this.setState({ selectGenderErrText: errorText});
    }
    else 
      this.setState({ selectGenderErrText: null});

    if (this.state.data.staffSelected === '') {
      this.setState({ selectStaffErrText: errorText});
    }
    else 
      this.setState({ selectStaffErrText: null});

    if (this.state.data.ccTypeSelected === '') {
      this.setState({ selectccTypeErrText: errorText});
    }
    else 
      this.setState({ selectccTypeErrText: null});

    if (this.state.data.name === '') {
      this.setState({ selectNameErrText: errorText});
    }
    else 
      this.setState({ selectNameErrText: null});
  }

  handleCloseSnack = () =>{
    this.setState({ snackOpen: false });
  }

  handleNameValidation = async() =>{
    if(this.state.data.name !== ''){
      let centerName = 'Zolo ' + this.state.data.name;
      let body = {name : centerName}
      validateCenterName(body).then((response) => {
        if (response && response.status === 'success') {
          this.setState({nameDuplicate: response.duplicate});
          if(this.state.nameDuplicate) {
            this.setState({nameInvalidText: 'Name is already in use', nameValidText: null, nameErrorText: null});
          }
          else {
            this.setState({nameValidText: 'Name is valid', nameInvalidText: null, nameErrorText: null});
          }
        }
      });
    }
  }

  render() {
    const { selectNameErrText } = this.state
    const { nameValidText } = this.state
    const { nameInvalidText } = this.state
    const { selectCityErrText } = this.state
    const { selectGenderErrText } = this.state
    const { selectccTypeErrText } = this.state
    const { selectStaffErrText } = this.state

    return (
      <MuiThemeProvider>
        <Header/>
        
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
          <div style={{ width:'250px', marginTop: '16px', display: 'flex', alignItems: 'flex-end' }}//style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap'}}
          >
            Name
            <Tooltip title="Don't prefix name with Zolo" placement="right">
              <IconButton aria-label="info" style = {{postion: 'relative'}}>
                <Info/>
              </IconButton>
            </Tooltip>
          </div>
          <div style={{ display: 'flex', flexWrap: 'wrap', flexDirection: 'row', position: 'relative'}}>
            <div style={{display: 'flex', marginRight: '10px', alignItems: 'flex-end', paddingBottom: '15px'}}>
              ZOLO
            </div>
            <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap'}}>
              <TextField
                  value={this.state.data.name}
                  onChange={this.handleChange('name')}
                  onBlur = {()=> this.handleNameValidation()}
                  margin='normal'
                  variant='outlined'
                  style={{ width: '200px' }}
                />
            </div>
                {selectNameErrText && (<FormHelperText style={{ color: 'red', position: 'absolute', bottom: '-1em' }}>{selectNameErrText}</FormHelperText>)}
                {nameValidText && <FormHelperText style={{ color: 'green', position: 'absolute', bottom: '-1em'}}>{nameValidText}</FormHelperText>}
                {nameInvalidText && <FormHelperText style={{ color: 'red', position: 'absolute', bottom: '-1em' }}>{nameInvalidText}</FormHelperText>}
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '16px' }}>
              <InputLabel htmlFor="selectCity">*Select City</InputLabel>
              <Select
                    value={this.state.data.citySelected}
                    onChange={this.handleChange('city')}
                    style={{ width: '250px', textAlign: 'left' }}
                  >
                    {
                      this.state.cities.map((city) => {
                        return <MenuItem key={city.city_id} value={city.city_name} ><ListItemText primary={city.city_name} /></MenuItem>
                      })
                    }
                  </Select>
              {selectCityErrText && <FormHelperText style={{ color: 'red' }}>{selectCityErrText}</FormHelperText>}
            </FormControl>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '16px' }}>
              <InputLabel htmlFor="selectCity">*Gender</InputLabel>
              <Select
                    value={this.state.data.genderSelected}
                    onChange={this.handleChange('gender')}
                    style={{ width: '250px', textAlign: 'left' }}
                  >
                    {
                      this.state.gender.map((gender) => {
                        return <MenuItem key={gender.id} value={gender.name} ><ListItemText primary={gender.name} /></MenuItem>
                      })
                    }
                  </Select>
              {selectGenderErrText && <FormHelperText style={{ color: 'red' }}>{selectGenderErrText}</FormHelperText>}
            </FormControl>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '16px' }}>
              <InputLabel htmlFor="ccType">*Cost Center Type</InputLabel>
              <Select
                    value={this.state.data.ccTypeSelected}
                    onChange={this.handleChange('ccType')}
                    style={{ width: '250px', textAlign: 'left' }}
                  >
                   {
                      this.state.ccType.map((type) => {
                        return <MenuItem key={type.id} value={type.name} ><ListItemText primary={type.name} /></MenuItem>
                      })
                    }
                  </Select>
              {selectccTypeErrText && <FormHelperText style={{ color: 'red' }}>{selectccTypeErrText}</FormHelperText>}
            </FormControl>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
            <FormControl style={{ marginTop: '16px' }}>
              <InputLabel htmlFor="selectStaff">*Staff</InputLabel>
              <Select
                    value={this.state.data.staffSelected}
                    onChange={this.handleChange('staff')}
                    style={{ width: '250px', textAlign: 'left' }}
                  >
                    {
                      this.state.staff.map((staff) => {
                        return <MenuItem key={staff.id} value={staff.name} ><ListItemText primary={staff.name} /></MenuItem>
                      })
                    }
                  </Select>
              {selectStaffErrText && <FormHelperText style={{ color: 'red' }}>{selectStaffErrText}</FormHelperText>}
            </FormControl>
          </div>
          <div className="zaps-form-actions">
            <RaisedButton
              label="Clear"
              primary={true}
              onClick={this.handleClear.bind(this)}
              buttonStyle={{ backgroundColor: 'red' }}
            />
            <RaisedButton style={{ marginLeft: '20px' }} label={`Submit`} primary={true} onClick={this.handleSubmit.bind(this)} disabled={this.state.submitDisable}/>
          </div>  
        </div>
        <Snackbar
            open={this.state.snackOpen}
            autoHideDuration={3000}
            onClose={this.handleCloseSnack.bind(this)}
            message={this.state.snackText}
          />
      </MuiThemeProvider>
    )
  }
}
export default AddCostCenter



// WEBPACK FOOTER //
// ./src/components/AddCostCenter.js